import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Spin, Tooltip } from 'antd';
import { ceil } from 'lodash';

import Drawer from '../../components/uiComponent/drawer/index';
import Pagination from '../../components/pagination/index';
import AgGrid from '../../components/ag-grid-table/index';


import { WarehouseWrapper } from './style';

import { convertUtcToEst } from '../../utils/helpers';

import { GetLocationHistories } from '../../slices/location-management';

import {STORAGE_IMAGE_URL} from '../../constants/storage';
const ProductImg = `${STORAGE_IMAGE_URL}/newImages/nestle.svg`;

const defaultColDef = {
  resizable: true,
  sortable: true
};

const LocationHistory = ({
  locationHistory,
  setLocationHistory,
  productId,
  locationProduct
}) => {
  const dispatch = useDispatch();

  const [page, setPage] = useState({ pageSize: 25, pageNumber: 1 });
  const [sortBy, setSortBy] = useState({ key: '', type : '' });

  const {
    fetchingLocationHistories,
    locationHistories,
    totalLocationHistoriesCount
  } = useSelector((state) => state?.locationManagement || {});

  useEffect(() => {
    dispatch(GetLocationHistories({
      id: productId,
      params: { page }
    }));
  }, []);

  const handlePagination = (number, key) => {
    const value = Number(number);
    let newPage = {};

    if (key === 'pageSize') newPage = { pageNumber: 1, pageSize: value };
    else newPage = { ...page, pageNumber: value };

    setPage(newPage);
    dispatch(GetLocationHistories({
      id: productId,
      params: { page: newPage, sortBy }
    }));
  };

  const refreshGridClick = () => {
    setSortBy({ key: '', type: '' });
    dispatch(GetLocationHistories({
      id: productId,
      params: { page }
    }));
  };

const onSortChange = (params) => {
    const value = params.columnApi.getColumnState().find(s => s.sort != null);

    if (value && [ 'quantity', 'created_at' ].includes(value?.colId)) {
      const { colId, sort } = value || {};
      setSortBy({ key: colId, type: sort });
      dispatch(GetLocationHistories({
        id: productId,
        params: {
          page,
          sortBy: { key: colId, type: sort }
        }
      }));
    }
  };

  const locationHistoryColumnDefinitions = [
    {
      headerName: 'Date',
      field: 'created_at',
      minWidth: 200,
      flex: 1,
      sortable: true,
      comparator: () => '',
      cellRenderer: ({ value }) => {
        if (!value) return '---';

        const date = convertUtcToEst(value, {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          hour12: true
        });

        return date;
      }
    },
    {
      headerName: 'Worker',
      field: 'user_id',
      minWidth: 120,
      flex: 1,
      sortable: false,
      cellRenderer: ({ value, data }) =>
        <span className="ellipse">{data.user_first_name || '---'}</span>
    },
    {
      headerName: 'Module',
      field: 'module_name',
      minWidth: 120,
      flex: 1,
      sortable: false,
      cellRenderer: ({ value }) => <Tooltip title={value || ''}>
        <span className="ellipse">{value || '---'}</span>
      </Tooltip>
    },
    {
      headerName: 'Action',
      field: 'action',
      minWidth: 120,
      flex: 1,
      sortable: false,
      cellRenderer: ({ value }) => value ? value.toUpperCase() : '---'
    },
    {
      headerName: 'Description',
      field: 'description',
      minWidth: 120,
      flex: 1,
      sortable: false,
      cellRenderer: ({ value }) => <Tooltip title={value || ''}>
        <span className="ellipse">{value || '---'}</span>
      </Tooltip>
    },
    {
      headerName: 'Quantity',
      field: 'quantity',
      minWidth: 100,
      flex: 1,
      sortable: true,
      comparator: () => 0,
      cellRenderer: ({ value, data }) => {
        value = data?.action.toLowerCase() === 'deduct' ? `-${value}` : data?.action.toLowerCase() === 'add'? `+${value}`: value;
        return (`${value || 0}`);
      }
    },
    {
      headerName: 'Notes',
      field: 'notes',
      minWidth: 120,
      flex: 1,
      sortable: false,
      cellRenderer: ({ value }) => <Tooltip title={value || ''}>
        <span className="ellipse">{value || 'N/A'}</span>
      </Tooltip>
    }
  ];

  const { pageNumber, pageSize } = page || {};

  return (
    <>
      <Drawer
        show={locationHistory}
        size="85%"
        className='to-location-drawer-wrapper'
        style={{ borderTopLeftRadius: 10, borderBottomLeftRadius: 10 }}
      >
        <WarehouseWrapper>
          <Spin tip='Loading...' spinning={fetchingLocationHistories}>
            <div className="location-history-overlay-wrapper">
              <div className="header-ui-wrapper">
                <div className="drawer-header-location">
                  <span onClick={() => setLocationHistory(false)} className="icon-arrow-left cursor-pointer" />
                  <h5>Product History</h5>
                </div>
              </div>
              <div className='product'>
                <div className='image-div'>
                  <div className='image-container'>
                    <img
                      src={locationProduct?.image_url || ProductImg}
                      alt='Img'
                      title='ProductImg'
                    />
                  </div>
                  <div className='content-div'>
                    <div className='quantity-section'>
                      <div className='section-items'>
                        <span className='heading-text'>Name</span>
                        <Tooltip placement='top' title={locationProduct?.name?.length > 28 ? locationProduct?.name : null}>
                          <span className='value-text'>{locationProduct?.name?.length > 28 ? locationProduct?.name.slice(0, 28) + '...' : locationProduct?.name || 'N/A'}</span>
                        </Tooltip>
                      </div>
                      <div className='section-items'>
                        <span className='heading-text'>Brand</span>
                        <Tooltip placement='top' title={locationProduct?.brand?.length > 28 ? locationProduct?.brand : null}>
                          <span className='value-text'>{locationProduct?.brand?.length > 28 ? locationProduct?.brand.slice(0, 28) + '...' : locationProduct?.brand || 'N/A'}</span>
                        </Tooltip>
                      </div>
                      <div className='section-items'>
                        <span className='heading-text'>{locationProduct?.identifier_type?.toUpperCase() || 'N/A'}</span>
                        <span className='value-text'>{locationProduct?.identifier_value || '-'}</span>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <AgGrid
                user_referrals={locationHistories}
                defaultColDef={defaultColDef}
                columnDefinitions={locationHistoryColumnDefinitions}
                onSortChange={onSortChange}
                rowHeight={55}
                height="250px"
              />
              <Pagination
                total={totalLocationHistoriesCount}
                totalPages={ceil((totalLocationHistoriesCount / pageSize) + 1)}
                pageNumber={pageNumber}
                pageLimit={pageSize}
                handleLimitChange={(e) => handlePagination(e, 'pageSize')}
                handlePageNumberChange={(e) => handlePagination(e, 'pageNumber')}
                handlePageChangeLeft={(e) => handlePagination(e, 'pageNumber')}
                handlePageChangeRight={(e) => handlePagination(e, 'pageNumber')}
                refreshGridClick={refreshGridClick}
              />
            </div>
          </Spin>
        </WarehouseWrapper>
      </Drawer>
    </>
  );
};

export default LocationHistory;